import repository from "@/api/auth.js";

export default {
  state: {
    sidebar: false,
    isInit: false,
    env: {
      siteName: "",
      version: "",
      appTimezone: "UTC",
      langs: [],
      storagePrefix: "",
      defaultBackground: "#ffffff"
    }
  },
  actions: {
    async fetchEnv({ state, commit }) {
      try {
        if (state.isInit) return true;
        const { data } = await repository.env();
        commit("setEnv", data);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  },
  getters: {
    getLangs(state) {
      return state.env.langs;
    },
    getSiteName(state) {
      return state.env.siteName;
    },
    getDefaultBackground(state) {
      return state.env.defaultBackground;
    },
    getBackendVersion(state) {
      return state.env.version;
    },
    getAppTimezone(state) {
      return state.env.appTimezone;
    },
    getStoragePrefix(state) {
      return state.env.storagePrefix;
    },
    getSidebar(state) {
      return state.sidebar;
    },
    isFeatureEnabled(state) {
      return feature => {
        if (state.env.features[feature]) {
          return state.env.features[feature];
        }
        return false;
      };
    }
  },
  mutations: {
    setEnv(state, payload) {
      state.env = payload;
      state.isInit = true;
    },
    setSidebar(state, payload) {
      state.sidebar = payload;
    }
  }
};
